var _g, _path, _path2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 142,
    height: 32,
    viewBox: "0 0 142 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3_40646)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_3_40646)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32Z",
    fill: "url(#paint0_linear_3_40646)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_3_40646)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.3 15.02C12.7421 15.0171 12.1851 15.0653 11.636 15.164C12.088 10.984 15.572 7.81799 19.72 7.81799C22.26 7.81799 24 9.06199 24 11.636C24 14.211 21.911 15.455 18.864 15.455C16.614 15.455 15.55 15.021 13.3 15.021M13.136 16.545C10.089 16.545 8 17.79 8 20.364C8 22.938 9.74 24.182 12.28 24.182C16.428 24.182 19.912 21.017 20.364 16.836C19.8149 16.9347 19.2579 16.9829 18.7 16.98C16.45 16.98 15.385 16.545 13.136 16.545Z",
    fill: "white",
    fillOpacity: 0.7
  }))))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M59.9065 26V10.1655H56.7744V16.6037H50.1158V10.1655H46.9837V26H50.1158V19.2138H56.7744V26H59.9065ZM63.7462 10.1655L64.0942 20.6058H66.7507L67.1103 10.1655H63.7462ZM63.3866 24.4455C63.3866 25.4896 64.2102 26.232 65.4051 26.232C66.6579 26.232 67.4699 25.4896 67.4699 24.4455C67.4699 23.3667 66.6579 22.6359 65.4051 22.6359C64.1986 22.6359 63.3866 23.3667 63.3866 24.4455Z",
    fill: "#FE6215"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M77.0866 26V12.7872H81.5876V10.1655H69.4536V12.7872H73.9429V26H77.0866ZM83.9425 26H86.9818V19.179C86.9818 17.3113 87.9794 16.0585 89.5803 16.0585C90.8447 16.0585 91.8423 16.8009 91.8423 18.6222V26H94.8932V17.7753C94.8932 14.91 93.1996 13.4948 90.8099 13.4948C88.4202 13.4948 87.3994 14.9796 87.1442 15.8613H86.9818V9.33026H83.9425V26ZM103.512 26.2204C107.027 26.2204 108.547 24.0279 108.674 22.4967H105.774C105.635 23.2623 104.754 23.8655 103.501 23.8655C101.9 23.8655 100.891 22.7287 100.891 21.1046V20.5246H108.79V19.1094C108.79 15.6293 106.552 13.4716 103.362 13.4716C100.299 13.4716 97.8977 15.4669 97.8977 19.1094V20.571C97.8977 24.2019 100.102 26.2204 103.512 26.2204ZM100.891 18.6686V18.541C100.891 16.8705 101.9 15.7685 103.373 15.7685C104.858 15.7685 105.832 16.8705 105.832 18.541V18.6686H100.891ZM111.946 26H115.066V18.9586C115.066 17.2997 116.018 16.1281 118.013 16.1281C118.488 16.1281 118.987 16.1629 119.219 16.2325V13.5876C118.987 13.5412 118.674 13.5064 118.256 13.5064C116.308 13.5064 115.403 14.7824 115.147 15.6177H114.997V13.692H111.946V26ZM126.597 26.2204C130.112 26.2204 131.632 24.0279 131.759 22.4967H128.859C128.72 23.2623 127.838 23.8655 126.585 23.8655C124.985 23.8655 123.975 22.7287 123.975 21.1046V20.5246H131.875V19.1094C131.875 15.6293 129.636 13.4716 126.446 13.4716C123.384 13.4716 120.982 15.4669 120.982 19.1094V20.571C120.982 24.2019 123.187 26.2204 126.597 26.2204ZM123.975 18.6686V18.541C123.975 16.8705 124.985 15.7685 126.458 15.7685C127.943 15.7685 128.917 16.8705 128.917 18.541V18.6686H123.975ZM134.671 24.2831C134.671 25.4548 135.576 26.232 136.689 26.232C137.838 26.232 138.743 25.4548 138.743 24.2831C138.743 23.0883 137.849 22.2879 136.689 22.2879C135.564 22.2879 134.671 23.0651 134.671 24.2831Z",
    fill: "#101828"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_3_40646",
    x: -2,
    y: 1.81799,
    width: 36,
    height: 36.364,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3_40646"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3_40646",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3_40646",
    x1: 2.5,
    y1: 42,
    x2: 43.5,
    y2: -32,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE6215"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E2944B"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3_40646"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_3_40646"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/Logo.9e90165f6c8ed8cc249b41f6087ada24.svg";
export { ForwardRef as ReactComponent };